import { useState } from 'react'
import {FormikConsumer, connect} from 'formik';
import { themeColor } from 'shared';

export const Debug = connect(({formik}) => {
  if (!formik.values._debug) return null

  const [open, setOpen] = useState(false)

  return <div className="generic-admin-box for-platform-admins p-305 pr-205 mb-6">
    <div
      style={{
        textTransform: 'uppercase',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        fontWeight: 500,
        padding: '.5rem',
        background: themeColor('purple-800'),
        color: themeColor('white'),
        letterSpacing: '1px',
      }}
      onClick={() => setOpen(!open)}
    >
      Form Debug
    </div>
    <FormikConsumer>
      {({ validationSchema, validate, ...rest }) => (
        <pre
          style={{
            fontSize: '80%',
            color: 'white',
            padding: '.25rem .5rem',
            overflowX: 'scroll',
            fontFamily: 'Monaco, Menlo, Consolas, ui-monospace, "Courier New", monospace',
            border: '1px solid white',
            display: open ? 'block' : 'none',
          }}
        >
          {JSON.stringify(rest, null, 2)}
        </pre>
      )}
    </FormikConsumer>
  </div>
})
